module.exports = __webpack_public_path__ + "bc013a982b1f4c3083b1a3fad709bf5f.jpg";